import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {map} from "rxjs/operators";
import {Serializer, SerializerResponse, Serializers} from '../../interfaces/serializer';
import {Site} from '../../interfaces/site';
import {AppState} from '../store';
import {selectSite} from '../init/init.selectors';
import {TypedAction} from '@ngrx/store/src/models';
import {Store} from '@ngrx/store';
import {
  deleteInfoNotifications,
  deleteInfoNotificationsSuccess,
  loadNotificationCenter,
  loadNotificationCenterSuccess
} from "./notificationCenter.actions";
import {NotificationCenterService} from "../../services/notification-center.service";
import {Notification} from "../../interfaces/notification";

@Injectable()
export class NotificationCenterEffects {
  private readonly _dataSet$: Observable<Serializer<Site>> = this._store.select(selectSite);

  private readonly _load$ = createEffect(() => this._actions$
    .pipe(
      ofType(loadNotificationCenter),
      withLatestFrom(this._dataSet$),
      switchMap(([_, dataSet]: [TypedAction<string>, Serializer<Site>]) => this._notificationCenterService.getNotifications(dataSet)
        .pipe(
          map((results: SerializerResponse<Serializers<Notification>>) => loadNotificationCenterSuccess({
            notifications: results.data
          }))
        )
      )
    )
  );

  private readonly _deleteInfoNotifications = createEffect(() => this._actions$
    .pipe(
      ofType(deleteInfoNotifications),
      withLatestFrom(this._dataSet$),
      switchMap(([_, dataSet]: [TypedAction<string>, Serializer<Site>]) => this._notificationCenterService.deleteInfoNotifications(dataSet)
        .pipe(
          map((results: SerializerResponse<Serializers<Notification>>) => deleteInfoNotificationsSuccess({
            notifications: results.data
          }))
        )
      )
    )
  );

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _actions$: Actions,
    private readonly _notificationCenterService: NotificationCenterService
  ) {}

}
